import useStore from "stores/index";
import { getSelectedClassId } from "stores/chatStore";
import { CLASSROOM_TYPES } from "types/classrooms";
import { getClassroomStore } from "stores/classroomStore";

export default function getChatDisabled(classroomId) {
	const classroom = getClassroomStore(useStore.getState()).getClassroomV2(classroomId || getSelectedClassId(useStore.getState()));
	if (classroom && classroomId) {
		// Disable chat for groups
		if (classroom.type.toLowerCase() === CLASSROOM_TYPES.GROUP) {
			return true;
		}
		return classroom.zoom?.policy?.chat_blocked === true;
	}
	return true;
}
